import { combineReducers } from 'redux';

import autocomplete from './autocomplete';
import board from './board';
import boardList from './boardList';
import chartsData from './chartsData';
import chartsManifest from './chartsManifest';
import editHistory from './editHistory';
import configs from './configs';
import layout from './layout';
import loginForm from './loginForm';
import network from './network';
import socket from './socket';
import user from './user';

export default combineReducers({
  autocomplete,
  board,
  boardList,
  chartsData,
  chartsManifest,
  editHistory,
  configs,
  layout,
  loginForm,
  network,
  socket,
  user,
});
